import classnames from 'classnames';
import React from 'react';

import { PopupBuilderTextContentSection } from '../contentTypes';
import { Div } from '../HTMLElement';
import { TextAlign } from '../interfaces';
import { buildSpacingClassNamesFromContent, buildVisibilityClassNamesFromContent, formatHtml } from '../util';
import { PropsWithCustomComponent, VariantsController } from '../VariantsController';

export interface PopupBuilderTextComponentProps extends PopupBuilderTextContentSection {}

const PopupBuilderTextComponent = ({ options, text }: PopupBuilderTextComponentProps) => {
  const textAlign = options?.textAlign as TextAlign;
  const headingType = options?.headingType as string;
  const margin = options?.margin && buildSpacingClassNamesFromContent('m', options.margin);
  const visibility = options?.visibility;
  const visibilityClassNames = visibility && buildVisibilityClassNamesFromContent(visibility);

  return (
    <React.Fragment>
      {options?.enabled && (
        <Div
          className={classnames('popup-builder-text-component', options.classes)}
          textAlign={textAlign}
          uiClassName={{ bs5: classnames(margin, visibilityClassNames) }}
        >
          {React.createElement(headingType, null, formatHtml(text))}
        </Div>
      )}
    </React.Fragment>
  );
};

export type PopupBuilderTextComponentVariants = '';

const PopupBuilderTextComponentController = (props: PropsWithCustomComponent<PopupBuilderTextComponentProps>) => (
  <VariantsController<PopupBuilderTextComponentProps, PopupBuilderTextComponentVariants>
    {...props}
    variantsControllerConfig={{
      defaultComponent: PopupBuilderTextComponent,
      name: 'PopupBuilderTextComponent',
    }}
  />
);
export { PopupBuilderTextComponentController as PopupBuilderTextComponent };
